var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPositionsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5296_14886)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.145508,
    width: 52,
    height: 52,
    rx: 12,
    fill: "#E6E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.987 20.0292L31.046 23.0735L26.3081 16.7538C26.289 16.7284 26.2643 16.7077 26.2359 16.6935C26.2075 16.6793 26.1761 16.6719 26.1443 16.6719C26.1125 16.6719 26.0812 16.6793 26.0528 16.6935C26.0243 16.7077 25.9996 16.7284 25.9806 16.7538L21.2452 23.0735L16.3017 20.0292C16.1569 19.9403 15.969 20.0597 15.9919 20.2298L17.9317 34.9716C17.9597 35.1722 18.1323 35.327 18.338 35.327H33.9558C34.1589 35.327 34.3341 35.1747 34.3595 34.9716L36.2993 20.2298C36.3196 20.0597 36.1343 19.9403 35.987 20.0292ZM26.1456 31.6505C24.5688 31.6505 23.2866 30.3683 23.2866 28.7915C23.2866 27.2147 24.5688 25.9325 26.1456 25.9325C27.7224 25.9325 29.0046 27.2147 29.0046 28.7915C29.0046 30.3683 27.7224 31.6505 26.1456 31.6505ZM26.1456 27.5651C25.4702 27.5651 24.9218 28.1136 24.9218 28.7915C24.9218 29.4669 25.4702 30.0179 26.1456 30.0179C26.821 30.0179 27.3694 29.4694 27.3694 28.7915C27.3694 28.1161 26.821 27.5651 26.1456 27.5651Z",
    fill: "#2D488E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5296_14886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0.145508)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionsIcon);
export default __webpack_public_path__ + "static/media/positions-icon.6b79c46e1db18b4dfbcac3855530d648.svg";
export { ForwardRef as ReactComponent };